module.exports = __webpack_public_path__ + "static/media/dcard_comm.851b5aeb.webp";